"use client";

import * as React from "react";

import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/shared/lib/utils";
import { Toggle } from "@/shared/ui/toggle";

export const filterToggleVariants = cva(
  "inline-flex cursor-pointer items-center justify-center gap-1.5 rounded-md border border-border bg-white font-normal whitespace-nowrap transition-colors text-muted-foreground hover:bg-muted hover:text-foreground aria-pressed:border-primary aria-pressed:bg-primary/10 aria-pressed:text-primary aria-pressed:hover:bg-primary/15 disabled:pointer-events-none disabled:opacity-50 dark:bg-card",
  {
    variants: {
      size: {
        default: "h-9 px-3 text-sm",
        xs: "px-2 py-0.5 text-xs gap-1",
      },
    },
    defaultVariants: { size: "default" },
  },
);

export type FilterToggleProps = React.ComponentProps<typeof Toggle> & VariantProps<typeof filterToggleVariants>;

export function FilterToggle({ className, size, ...props }: FilterToggleProps) {
  return <Toggle {...props} className={cn(filterToggleVariants({ size }), className)} />;
}
